<div class="error_page">
    <div class="error_page_name">Load Error</div>
    <img src="/assets/img/404-error.png" alt="" class="error_page_img">
    <div class="error_page_title">Whoops!</div>
    <div class="error_page_text">An error occurred. Please check your internet connection and refresh the page.</div>
</div>
<div id="roadmap-paint-finished"></div>
